import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { spaceXXL } from '@xing-com/tokens';

import { adSlotConfigPublift } from '../../ad-slot-config-publift';
import { useRegisterZone } from '../../hooks';

const AdWrapper = styled.div`
  width: 728px;
  height: 90px;
  position: relative;
  z-index: 1;
  margin: ${spaceXXL};
`;

export const DisplayAdLoginSlotPublift: React.FC = () => {
  const isBigScreen = useMatchMedia(
    '(min-width: 1584px) and (min-height: 900px)'
  );

  const slotId = adSlotConfigPublift.Login.content.id;
  const shouldRegisterZone = isBigScreen === true;

  useRegisterZone(slotId, { skip: !shouldRegisterZone });

  if (!shouldRegisterZone) {
    return null;
  }

  return (
    <NoSSR>
      <AdWrapper>
        <div
          id={slotId}
          data-fuse={adSlotConfigPublift.Login.content.fuseTag}
        ></div>
      </AdWrapper>
    </NoSSR>
  );
};
